'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.performance', {
    url: 'performance/?tab',
    templateUrl: '/views/partials/clinic/performance.html',
    controller: 'ClinicPerformanceCtrl',
    reloadOnSearch: false,
    resolve: {
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Performance - ' + clinic.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicPerformanceCtrl', function(
  $scope,
  $stateParams,
  ClinicConfig,
  $location,
  OCModalUtil,
  IframeService,
) {
  IframeService.setupFunctionCallHandler($scope);
  IframeService.addResizeHandler({
    getElement: () => document.getElementById('performance-container'),
  });

  const tab = $stateParams.tab || 'overview';
  const performanceUrl = `${ClinicConfig.CLINIC_APP_V4_URL}#/performance/${$stateParams.id}/?tab=${tab}`;
  const iframeEl = angular.element('#js-performance-iframe')[0];
  iframeEl.src = encodeURI(performanceUrl);

  $location.url($location.path());

  function reloadIframe() {
    IframeService.sendMessage({
      type: 'reload',
      iframe: iframeEl,
    });
  }

  $scope.openOCProOptInModal = function() {
    OCModalUtil.showModal(
      'clinicOCProOptIn',
      {
        clinic: $scope.clinic,
        reloadIframe,
      },
    );
  };
});
